import { useRef } from 'react';
import gettext from '@sdk/lang/gettext';
import useToast from '@sdk/common/toast/useToast';
import { Feature } from '@sdk/common/features';
import { SUBSCRIPTION_NAMES } from '@sdk/account/constants';
import useAuth from '@sdk/authentication/useAuth';

export const useExportButton = ({ getData, isOrgFeatureEnabled }) => {
  const { showErrorToast } = useToast();
  const { orgSettings } = useAuth();
  const formRef = useRef(null);

  const submit = async () => {
    if (!isOrgFeatureEnabled(Feature.fileExport)) {
      showErrorToast(
        gettext('%(subscriptionName)s required', {
          subscriptionName: SUBSCRIPTION_NAMES[orgSettings.premiumFeatures[Feature.fileExport]],
        })
      );
    }

    const data = JSON.stringify(await getData());

    formRef.current.elements.data.value = data;
    formRef.current.submit();
  };

  return {
    submit,
    formRef,
  };
};
